import React from "react";
//outsource
import { Input, Form } from "antd";

//components

const ServiceName = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="name"
      label="Name"
      rules={[
        {
          required: true,
          message: "Please insert the name",
        },
      ]}
    >
      <Input placeholder="Name" />
    </Form.Item>
  );
};

export default ServiceName;
